import { FallbackProps } from 'react-error-boundary';
import image from 'src/assets/images/something-went-wrong.png';

const FallbackComponent = ({ error }: FallbackProps) => {
  return (
    <div className="min-h-screen w-full bg-layout-content flex items-center justify-center">
      <div className="flex flex-col items-center max-w-3xl px-4">
        <img
          src={image}
          alt="Something went wrong"
          className="mb-xl w-auto max-h-40 2xl:max-h-80"
        />
        <h1 className="text-h1 font-bold text-center">Uh...Oh...! Something went wrong</h1>
        <p className="mt-s-plus mb-m font-medium text-neutral-n7">
          Please reload the page or copy the error message and send an email to our Administrator
          via admin.smartoffice@stengg.com
        </p>
        <div className="mb-m bg-neutral-n3 border-neutral-n5 p-3 border rounded-soft text-neutral-n7">
          <div>{(error as any)?.message}</div>
          <div
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {(error as any)?.stack}
          </div>
        </div>
        <div className="flex gap-s-plus">
          <button
            onClick={() => window.location.reload()}
            className="px-xxl py-s-plus btn-primary text-white rounded-rounded"
          >
            Reload
          </button>
          <button
            onClick={() => {
              navigator.clipboard.writeText(`${(error as any)?.message}\n${(error as any)?.stack}`);
            }}
            className="px-xxl py-s-plus btn-other border-brand-primary-base text-brand-primary-base rounded-rounded"
          >
            Copy
          </button>
        </div>
      </div>
    </div>
  );
};

export { FallbackComponent };
